import { useMutation } from "@tanstack/react-query";
import apiClient from "@apis/index";
import Routes from "@apis/routes";

export const useContactUs = () => {
  return useMutation({
    mutationFn: (data: {
      user_comment: string;
      screen_name: string;
      subject_prefix?: string;
    }) => apiClient.post(Routes.CONTACT_US, data),
  });
};

export const usePublicContactUs = () => {
  return useMutation({
    mutationFn: (data: {
      name: string;
      email: string;
      phone_number_country_code: string;
      phone_number: string;
      user_comment: string;
      org_id: number;
      screen_name: string;
    }) => apiClient.post(Routes.PUBLIC_CONTACT_US, data),
  });
};
